import { Grow, Paper, Popper } from '@mui/material';
import {
  bindHover,
  bindPopper,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import { ReactNode, cloneElement } from 'react';
import { useWorkspaceUser } from 'src/hooks/useWorkspace';
import { UserProfileShort } from '../UserProfileShort';

type UserProfileShortPopoverProps = {
  userId: string;
  children: ReactNode;
};

export const UserProfileShortPopoverTrigger = ({
  children,
  userId,
}: UserProfileShortPopoverProps) => {
  const user = useWorkspaceUser(userId);

  const popupState = usePopupState({
    variant: 'popover',
    popupId: `user-profile-short`,
  });

  if (!user) return null;

  return (
    <>
      {cloneElement(children as any, bindHover(popupState))}
      <Popper
        {...bindPopper(popupState)}
        placement="top-start"
        sx={{ zIndex: 'modal' }}
      >
        <Grow in={popupState.isOpen}>
          <Paper
            elevation={3}
            sx={{
              p: 1.5,
              width: 300,
              maxWidth: '100%',
              bgcolor: (t) => t.palette.background.default,
            }}
          >
            <UserProfileShort user={user} />
          </Paper>
        </Grow>
      </Popper>
    </>
  );
};
